export function formatDuration(milliseconds) {
    const totalSeconds = Math.max(0, Math.round((Number(milliseconds) || 0) / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map(v => String(v).padStart(2, '0')).join(':');
}

export async function fetchSources({ requestSources, spaceId, timeRange, search }) {
    const { startDate, endDate } = timeRange || {};
    const data = await requestSources.get({
        urlParams: { spaceId },
        requestParams: {
            ...(search && { search }),
            ...(startDate && { startDate }),
            ...(endDate && { endDate }),
        },
    });

    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    return items.map(item => ({ id: item, name: item }));
}

export async function fetchGroups({ requestGroups, spaceId, search }) {
    const requestParams = { ...(search && { search }) };

    const data = await requestGroups.get({
        urlParams: { spaceId },
        requestParams,
    });
    if (data?.items && Array.isArray(data.items)) return data.items;
    if (Array.isArray(data)) return data;
    return [];
}
